import React from 'react'
import { Tabs, Spin } from 'antd'
import { ILandingPage, landingPagesApi } from 'api/landingPages'
import { showServerError } from 'shared/utils/showServerError'
import { BannerList } from '../Banners/BannerList'
import { PoloClubServices } from './PoloClubServices'
import { PoloClubCategories } from './PoloClubCategories'
import { PoloClubBookings } from './PoloClubBookings'

// slug лендинг-страницы (засижен миграцией на бэкенде)
export const POLO_CLUB_SLUG = 'ruspoloclub'

export const PoloClub: React.FC = () => {
  const [page, setPage] = React.useState<ILandingPage | null>(null)
  const [isLoading, setIsLoading] = React.useState(true)

  React.useEffect(() => {
    landingPagesApi
      .getBySlug(POLO_CLUB_SLUG)
      .then((res) => setPage(res.data))
      .catch(showServerError)
      .finally(() => setIsLoading(false))
  }, [])

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 80 }}>
        <Spin size='large' />
      </div>
    )
  }

  return (
    <div style={{ paddingBottom: 80 }}>
      <Tabs
        defaultActiveKey='bookings'
        items={[
          {
            key: 'bookings',
            label: 'Записи',
            children: <PoloClubBookings pageSlug={POLO_CLUB_SLUG} />
          },
          {
            key: 'services',
            label: 'Услуги',
            children: (
              <PoloClubServices
                pageSlug={POLO_CLUB_SLUG}
                exclusiveSlots={page?.exclusive_slots === true}
                onExclusiveSlotsChange={(value) =>
                  setPage((prev) =>
                    prev ? { ...prev, exclusive_slots: value } : prev
                  )
                }
              />
            )
          },
          {
            key: 'categories',
            label: 'Категории',
            children: <PoloClubCategories pageSlug={POLO_CLUB_SLUG} />
          },
          {
            key: 'banners',
            label: 'Баннеры',
            children: (
              <BannerList
                pageSlug={POLO_CLUB_SLUG}
                pageId={page?._id}
              />
            )
          }
        ]}
      />
    </div>
  )
}
